<template>
    <div class="content-dashboard">
        <div class="title">회원 현황</div>
        <div class="chart-select-common">
            <el-date-picker
              v-model="dateData"
              type="date"
              @change="getList"
            />
        </div>
        <div class="chart-donut" id="donut"></div>
        <div class="box-statistics-common">
            <div class="statistics-circle-common green"></div>
            <div class="statistics-title-common">모든회원</div>
            <div class="statistics-text-common">{{ returnCommas(totalCount) }}명</div>
        </div>
        <div
            class="box-statistics-common"
            v-for="(item, index) in chartData"
            :key="`chartItem${index}`"
        >
            <div class="statistics-circle-common" :style="`background: ${item.itemStyle.color}`"></div>
            <div class="statistics-title-common">{{ item.name }}</div>
            <div class="statistics-text-common">{{ returnCommas(item.value) }}명({{  (item.value / totalCount * 100).toFixed(2) }}%)</div>
        </div>
    </div>
</template>


<script>
import util from "@/mixins/util";
import * as echarts from "echarts";
import dateMixins from "@/mixins/dateMixins";
// import NumberMixins from "@/mixins/NumberMixins"
export default {
    name: "DashboardMemberLayout",
    mixins: [
        // NumberMixins
        dateMixins
    ],
    components: {},
    props: {},
    data() {
        return {
            totalCount: 0,
            chartData: [],
            dateData : new Date(),
            donutChart: null,
        };
    },
    beforeRouterEnter() {},
    created() {
        this.getList();
    },
    mounted() {

    },
    beforeUnmount() {},
    unmounted() {},
    computed: {},
    methods: {
        returnCommas(price) {
            if (!util.isEmpty(price)) {
                return util.Number.numFormat(price);
            } else {
                return 0;
            }
        },
        getList() {
            let params ={};
            params.date = this.returnDateFormat(this.dateData,"YYYY-MM-DD");
            this.$api.$dash.getMemberList(params).then(data => data.Data.Result).then(res => {
                if (res.Info.status) {
                    this.dashData = res.List;
                } else {
                    this.dashData = [];
                }
                this.setData();
            })
        },
        setData(){
            this.totalCount = this.dashData.TotalCnt;
            this.chartData = [
                {
                    value: this.dashData.CurrMemberCnt,
                    name: "기존회원",
                    itemStyle: {
                        color: "orange",
                        decal: {
                            symbol: "none",
                        },
                    },
                },
                {
                    value: this.dashData.NewMemberCnt,
                    name: "신규회원",
                    itemStyle: {
                        color: "blue",
                        decal: {
                            symbol: "none",
                        },
                    },
                },
            ];
            this.setDonut();
        },

        setDonut() {
            
            let chartDom = document.getElementById("donut");
            this.donutChart = echarts.init(chartDom, null, {});
            let option = {
                tooltip: {
                    trigger: "item",
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: ["40%", "70%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: "center",
                        },
                        labelLine: {
                            show: false,
                        },
                        data: this.chartData,
                    },
                ],
            };
            this.donutChart.clear();
            this.donutChart.setOption(option);
        },
    },
    watch: {},
};
</script>
